import { STOREFRONT } from './constants.js';

export async function storefrontFetch(shopDomain, query, variables) {
  const res = await fetch(
    `https://${shopDomain}/api/${STOREFRONT.API_VERSION}/graphql.json`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query, variables }),
    }
  );
  if (!res.ok) throw new Error(`Storefront API ${res.status}`);
  const json = await res.json();
  if (json.errors?.length) throw new Error(json.errors[0].message);
  return json.data;
}
